import React from 'react';
import Accordion from '@components/Accordion/Accordion';

type FAQItem = { 
  faq_title: string; 
  faq_content: React.ReactNode;
};
interface FAQSectionProps {
  title?: string;
  description?: string | React.ReactNode;
  faqs: FAQItem[];
  isLoading?: boolean;
}

const FAQSection: React.FC<FAQSectionProps> = ({
  title = 'FAQs',
  description,
  faqs,
  isLoading = false,
}) => {
  if (!isLoading && faqs.length === 0) return null;
  const skeletonCount = faqs.length || 3;
  return (
    <div className="faq-block">
      {title && <h2 className="faq-heading">{title}</h2>}
      {description && <p className="faq-description">{description}</p>}

      {isLoading ? (
        <>
          {[...Array(skeletonCount)].map((_, idx) => (
            <div key={idx} className="accordion-items placeholder-glow mb-4">
              <span className="placeholder col-10 d-block mb-2" />
              <span className="placeholder col-7 d-block mb-1" />
              <span className="placeholder col-4 d-block mb-1" />
            </div>
          ))}
        </>
      ) : (
        <Accordion defaultActiveKey="0">
          {faqs.map((faq, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>{faq.faq_title}</Accordion.Header>
              <Accordion.Body>
                <div>{faq.faq_content }</div> 
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </div>
  );
};

export default FAQSection;
